import { type Theme } from "@mui/material";

import { type MuiThemeComponentOverride } from "./types";

export function getMuiListItemButton(theme: Theme): MuiThemeComponentOverride<"MuiListItemButton"> {
  const inactiveNavItemColor = theme.palette.text.secondary;

  return {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          
          // Selection (e.g. notifications list) — keep contrast on colored backgrounds.
"&.Mui-selected": {
            "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
              color: "inherit",
            },
            color: theme.palette.primary.contrastText,
          },
          

"&.active": {
            " *": { color: theme.palette.brand.white[100].main },
            backgroundColor: theme.palette.brand.blue[300].main,
          },
          
// Inactive nav-style rows: same medium grey for icon + label (matches main sidebar).
"&:not(.active)": {
            color: inactiveNavItemColor,
          },
          
"&:not(.active) .MuiListItemIcon-root": {
            color: "inherit",
          },
          
          "&:not(.active) .MuiListItemText-primary": {
            color: "inherit",
          },
          borderRadius: "0.25rem",
        },
      },
    },
  };
}
